import React from 'react';
import classNameBind from 'classnames/bind';
import { TextField } from '../../../TextField';
import styles from './SearchBar.module.css';

const bindClasses = classNameBind.bind(styles);

const SearchBar = ({
  placeholder,
  value,
  onChange,
  disabled,
  t,
  dataId,
}) => (
  <div className={bindClasses('SearchBar')} data-ppuc-id={dataId}>
    <TextField
      name="search"
      icon="search"
      placeholder={placeholder || t('SearchableMultiselectListbox.search')}
      value={value}
      onChange={onChange}
      clearable
      disabled={disabled}
    />
  </div>
);

SearchBar.defaultProps = {
  placeholder: null,
  disabled: false,
  dataId: 'SearchableMultiselectListbox.SearchBar',
};

export { SearchBar };
